import { Box } from "@mui/material";
import React, { useState } from "react";
import { isMobile } from "react-device-detect";

import { DocumentModal } from "components/DocumentModal";

import { useFileActionHandler, useFileMap } from "fileBrowser/hooks/filesHooks";

import { FileAction, FileData, useGameRoom } from "../context/GameContext";
import { useWindowTilesContext } from "../desktopWindow/context/WindowTilesContext";

import BrowserIcon from "assets/img/game-room/safari.png";
import FileTile, { Tile, TileText } from "fileBrowser/components/FileTile";

export const GameDesktopFiles = () => {
	const { fileMap } = useFileMap();
	const { desktopFiles: currentFolderFiles } = useGameRoom();
	const { openWindow } = useWindowTilesContext();
	const [protectedFilePayload, setProtectedFilePayload] = React.useState<any>();

	const handleFileAction = useFileActionHandler({
		handleSelectFolder: (id) => {
			const fileToOpen = fileMap[id];
			const windowWidth = 800;
			const windowHeight = 600;
			openWindow({
				id,
				componentName: "FileBrowser",
				componentProps: { file: fileToOpen, rootFolderId: id },
				windowTitle: fileToOpen.name,
				size: { height: windowHeight, width: windowWidth },
				minSize: { height: windowHeight, width: windowWidth },
				resizeable: true,
			});
		},
		isFromHomeScreen: true,
		unlockFile: setProtectedFilePayload,
	});

	const [selected, setSelected] = useState<string | undefined>("");

	const files = [...currentFolderFiles].map((fileId) => fileMap[fileId]).filter(Boolean) as FileData[];

	return (
		<>
			<Box
				sx={(theme) => ({
					display: "flex",
					flexDirection: "column",
					flexWrap: "wrap",
					height: "88%",
					alignContent: "flex-start",
					overflow: "auto",
					// Hide scroll
					"&::-webkit-scrollbar": {
						display: "none",
					},
					[theme.breakpoints.down("sm")]: {
						marginTop: "48px",
					},
				})}
			>
				{isMobile && (
					<Box sx={{ minHeight: 150 }}>
						<Tile id={"item-desktop"} onClick={() => window.open("https://google.com", "_blank")}>
							<img src={BrowserIcon} alt="Browser" style={{ width: 60, height: 60 }} />
							<TileText sx={{ color: "#fff" }}>Browser</TileText>
						</Tile>
					</Box>
				)}
				{files
					.filter((item) => !item.isRootDir)
					.map((item) => (
						<Box sx={{ minHeight: 150 }} key={item.id}>
							<FileTile
								id={"item-desktop"}
								fileData={item}
								onClick={() => setSelected(item.id)}
								onDoubleClick={() => handleFileAction(item, FileAction.DOUBLE_CLICK)}
								textColor="#fff"
								selected={item.id === selected}
							/>
						</Box>
					))}
			</Box>

			{/* <List
				component="nav"
				sx={(theme) => ({
					p: "8px 16px",
					[theme.breakpoints.down("mobile")]: {
						mt: "41px",
					},
				})}
			>
				{isMobile && (
					<ListItemButton
						id={"item-desktop"}
						onClick={() => window.open("https://google.com", "_blank")}
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							mb: "8px",
							borderRadius: "5px",
							p: "8px",
							justifyContent: "center",
							maxWidth: 120,
						}}
					>
						<img src={BrowserIcon} alt="Browser" style={{ width: 60, height: 60 }} />
						<Typography
							component="span"
							textAlign="center"
							fontSize="0.75rem"
							marginTop={"8px"}
							color={theme.desktop?.fileTextColor || getInvertColor(theme.palette.primary.main)}
							sx={(theme) => ({
								wordBreak: "break-word", // use "break-word" to allow text wrapping
								display: "-webkit-box", // necessary for multi-line ellipsis
								WebkitLineClamp: 2, // limit to 2 lines
								WebkitBoxOrient: "vertical", // specify the box orientation
								overflow: "hidden", // hide overflow
								textOverflow: "ellipsis", // add ellipsis at the end
								width: "100%",
								fontWeight: 600,
								[theme.breakpoints.down("mobile")]: {
									fontSize: "14px",
								},
							})}
							title={"Browser"}
						>
							Browser
						</Typography>
					</ListItemButton>
				)}
				{[...currentFolderFiles]
					.map((fileId) => fileMap[fileId])
					.filter(Boolean)
					.map((file: FileData, idx) => {
						return (
							<ListItemButton
								id={"item-desktop"}
								key={file?.id}
								onDoubleClick={() => handleFileAction(file, FileAction.DOUBLE_CLICK)}
								onClick={() => {
									setSelected(file?.id);
									if (isMobile) handleFileAction(file, FileAction.DOUBLE_CLICK);
								}}
								selected={file?.id === selected}
								className={idx === 0 ? GameTutorialElements.FILE_TILE : ""}
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									mb: "8px",
									borderRadius: "5px",
									p: "8px",
									justifyContent: "center",
									maxWidth: 120,
									"&:last-child": { mb: "8px" },
								}}
							>
								{file?.protection?.locked ? (
									<LockedFile type={file?.isDir ? "folder" : "file"} />
								) : file?.isDir ? (
									<FolderIcon />
								) : isImageUrl(file?.thumbnailUrl) ? (
									<Thumbnail src={file!.thumbnailUrl!} alt="" />
								) : isAudio(file!.fileUrl!) ? (
									<AudiotrackIcon height="60" width="60" />
								) : isVideo(file!.fileUrl!) ? (
									<MovieIcon height="60" width="60" />
								) : (
									<FileIcon />
								)}
								<Typography
									component="span"
									textAlign="center"
									fontSize="0.75rem"
									marginTop={"8px"}
									color={theme.desktop?.fileTextColor || getInvertColor(theme.palette.primary.main)}
									sx={(theme) => ({
										wordBreak: "break-word", // use "break-word" to allow text wrapping
										display: "-webkit-box", // necessary for multi-line ellipsis
										WebkitLineClamp: 2, // limit to 2 lines
										WebkitBoxOrient: "vertical", // specify the box orientation
										overflow: "hidden", // hide overflow
										textOverflow: "ellipsis", // add ellipsis at the end
										width: "100%",
										fontWeight: 600,
										[theme.breakpoints.down("mobile")]: {
											fontSize: "14px",
										},
									})}
									title={file?.name}
								>
									{file?.name}
								</Typography>
							</ListItemButton>
						);
					})}
			</List> */}
			<DocumentModal
				isOpen={!!protectedFilePayload}
				onClose={() => setProtectedFilePayload(undefined)}
				data={protectedFilePayload}
			/>
		</>
	);
};

// const LockedFile: React.FC<any> = ({ type }) => {
// 	return (
// 		<>
// 			{type === "file" ? (
// 				<FileIcon style={{ position: "relative" }} />
// 			) : (
// 				<FolderIcon style={{ position: "relative" }} />
// 			)}
// 			<LockIcon sx={{ position: "absolute", top: "20%", left: "40%" }} />
// 		</>
// 	);
// };
